import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notificationBtn: {
      position: 'relative',
      display: 'block',
    },
    notificationBadge: {
      position: 'absolute',
      display: 'none',
      textAlign: 'center',
      top: theme.spacing(-0.4),
      right: theme.spacing(-0.25),
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      background: theme.palette.error.main,
      borderRadius: '50%',
    },
    notificationCount: {
      fontSize: 12,
      fontWeight: 600,
      textAlign: 'center',
      color: theme.palette.primary.contrastText,
    },
    showBadge: {
      display: 'block',
    },
    /**
     * VE-26426: the header download icon. Hidden until a download session
     * exists — the aiWARE app-bar widget captures its `rightActions` once at
     * mount, so the icon is always mounted and only its visibility changes.
     */
    downloadBtn: {
      position: 'relative',
      display: 'none',
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      color: theme.palette.primary.contrastText,
    },
    /**
     * Sized by `applyDownloadIconState`, not here: the arrow is drawn at full
     * size normally and smaller while the ring turns, which is the trick Chrome
     * uses to keep the two from crowding each other.
     */
    downloadIcon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      fill: 'currentColor',
    },
    /** The ring that spins around the arrow while bytes are moving. */
    downloadRing: {
      position: 'absolute',
      inset: 0,
      display: 'none',
      border: '2px solid transparent',
      borderTopColor: 'currentColor',
      borderRadius: '50%',
      animation: '$downloadSpin 1s linear infinite',
    },
    '@keyframes downloadSpin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  })
);
